/** @format */

import React, { useState } from "react";
import { Button, Modal } from "antd";
import { SlidersTwoTone } from "@ant-design/icons";
import { k8sNodes } from "./AccountEdgeDeployments.types";

interface IK8sModalProps {
	k8sExtIp: string;
	k8sExtPort: number;
	k8sNodes: k8sNodes[];
}

const K8sModal: React.FC<IK8sModalProps> = ({
	k8sExtIp,
	k8sExtPort,
	k8sNodes,
}) => {
	const [isK8sModalVisible, setIsK8sModalVisible] = useState<boolean>(false);

	const showK8sModal = () => {
		setIsK8sModalVisible(true);
	};

	const handleK8sModalCancel = () => {
		setIsK8sModalVisible(false);
	};

	const renderK8sReservedForTraining = (nodeReserve: boolean) => {
		if (nodeReserve) {
			return "true";
		} else if (!nodeReserve) {
			return "false";
		}
	};

	const renderK8sTrainingCapable = (nodeTraining: boolean) => {
		if (nodeTraining) {
			return "true";
		} else if (!nodeTraining) {
			return "false";
		}
	};

	return (
		<div>
			<Button shape="circle" onClick={showK8sModal}>
				<SlidersTwoTone />
			</Button>
			<Modal
				mask={false}
				title={<span id="k8s-modal-title">K8s</span>}
				open={isK8sModalVisible}
				onCancel={handleK8sModalCancel}
				footer={[
					<Button key="close" onClick={handleK8sModalCancel} type="primary">
						Close
					</Button>,
				]}>
				<div className="k8s-content-div info">
					<p id="k8s-info-title">K8s Info</p>
					<div className="node-div">
						<ul>
							{k8sExtIp ? (
								<li>
									<span>K8s ext IP:</span> {k8sExtIp}
								</li>
							) : null}
							{k8sExtPort ? (
								<li>
									<span>K8s ext port:</span> {k8sExtPort}
								</li>
							) : null}
						</ul>
					</div>
				</div>
				<div className="k8s-content-div nodes">
					<p>K8s Nodes</p>
					{k8sNodes !== undefined
						? k8sNodes.map((node) => {
								return (
									<div className="node-div" key={node.name}>
										<ul>
											<li>
												<span>Name:</span> {node.name}
											</li>
											<li>
												<span>Reserved for training:</span>{" "}
												{renderK8sReservedForTraining(node.reservedForTraining)}
											</li>
											<li>
												<span>Training capable:</span>{" "}
												{renderK8sTrainingCapable(node.trainingCapabale)}
											</li>
										</ul>
									</div>
								);
						  })
						: null}
				</div>
			</Modal>
		</div>
	);
};

export default K8sModal;
